import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  // 获取模板列表
  getTemplateList: (params) => {
    return defHttp.get({ url: `/aiad/graphic-text-fission/templates`, params });
  },
  // 保存图文模板
  createTemplate: (params) => {
    return defHttp.post({ url: `/aiad/graphic-text-fission/templates`, params });
  },
  // 更新图文模板
  updateTemplate: (id, params) => {
    return defHttp.put({ url: `/aiad/graphic-text-fission/templates/${id}`, params });
  },
  // 图文模板详情
  getTemplateDetail: (id) => {
    return defHttp.get({ url: `/aiad/graphic-text-fission/templates/${id}` });
  },
  // 删除图文模板
  deleteTemplate: (id) => {
    return defHttp.delete({ url: `/aiad/graphic-text-fission/templates/${id}` });
  },

  // 计划列表
  getPlanList: (params) => {
    return defHttp.get({ url: `/aiad/graphic-text-fission/plans`, params });
  },
  // 创建计划
  createPlan: (params) => {
    return defHttp.post({ url: `/aiad/graphic-text-fission/plans`, params });
  },

  // 查询合成结果结果列表
  getFissionResults: (
    planId: string,
    params = {
      pageSize: 9999,
    },
  ) => {
    return defHttp.get({
      url: `/aiad/graphic-text-fission/plans/generate/results`,
      params: {
        planId,
        ...params,
      },
    });
  },
});
